/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Constants from '../../Config/Config';
import $ from 'jquery';
import Parser from 'html-react-parser';
import ReactPixel from 'react-facebook-pixel';
const ajaxurl = Constants.URL.root+'/wp-admin/admin-ajax.php';
//import CartForm from './CartForm';

export default class SavedItems extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
			cartLoading: false,
			cartContent: null
        }
	    this.addToCart = this.addToCart.bind(this);
  	}

	addToCart() {
		const {savedItems, viewArray, frameImage} = this.props;

		const cartTotal = savedItems[viewArray].cart1ItemTotal;
		const quantity = savedItems[viewArray].qty;
		const frameTotal = savedItems[viewArray].frameTotal;
		const frameWidth = savedItems[viewArray].actualFrameSizeW;
		const frameHeight = savedItems[viewArray].actualFrameSizeH;
		const item_id = savedItems[viewArray].selectedLayout.get('id');
		const product_name = savedItems[viewArray].selectedLayout.get('name');
		const frameImageOriginal = frameImage === null ? '' : frameImage;
		const canvasImage = savedItems[viewArray].canvasThumbImage;
		const pictureHeight = savedItems[viewArray].frameImageHeight;
		const pictureWidth = savedItems[viewArray].frameImageWidth;
		let wrappingName, stretchingName, stretchingTotal, hangingName, frameName, canvasFrameTotal;

		if (savedItems[viewArray].selectedWrapping.size > 0) {
			wrappingName = savedItems[viewArray].selectedWrapping.getIn(['title','rendered']);
		}

		if (savedItems[viewArray].selectedStretching.size > 0) {
			stretchingName = savedItems[viewArray].selectedStretching.getIn(['title','rendered']);
			stretchingTotal = savedItems[viewArray].stretchingTotal;
		}

		if (savedItems[viewArray].selectedHanging.size > 0) {
			hangingName = savedItems[viewArray].selectedHanging.getIn(['title','rendered']);
		}

		if (savedItems[viewArray].selectedFrame.size > 0) {
			frameName = savedItems[viewArray].selectedFrame.get('name');
			canvasFrameTotal = savedItems[viewArray].canvasFrameTotal;
		}

  		// Update QTY
  		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				cartQty: parseFloat(quantity) + parseFloat(this.props.cartQty),
				customizeQTY: parseFloat(quantity)
			}
		});
		var self = this;
  		self.setState({cartLoading: true});
  		// Add to cart
		$.ajax(ajaxurl, {
			method: "POST",
			dataType: 'json',
			data: 'action=add_item_to_cart&cartTotal='+cartTotal+'&quantity='+quantity+'&frameTotal='+frameTotal+'&frameWidth='+frameWidth+'&frameHeight='+frameHeight+'&item_id='+item_id+'&product_name='+product_name+'&frameImageOriginal='+frameImageOriginal+'&canvasImage='+canvasImage+'&pictureHeight='+pictureHeight+'&pictureWidth='+pictureWidth+'&wrappingName='+wrappingName+'&stretchingName='+stretchingName+'&stretchingTotal='+stretchingTotal+'&hangingName='+hangingName+'&frameName='+frameName+'&canvasFrameTotal='+canvasFrameTotal,
			success: function (res) {
				self.setState({cartContent: res.message, cartLoading: false});
				ReactPixel.track( 'AddToCart' );
			}
		});
  	}

    render() {
    	const {savedItems, viewArray} = this.props;
    	//console.log(viewArray)
        return (
        	<>
				{savedItems.filter( ( item, key ) =>
					key === parseFloat(viewArray)
					).map( (item) =>
						<div key={item.selectedLayout.get('id')} className="viewCompare-wrapper">

			        		<div className="viewCompare-frame-wrapper">
								<img src={item.canvasImage} alt={item.selectedLayout.get('name')} />
	    					</div>

							{item.selectedStretching.size > 0 &&
				        		<div className="popLine">
					        		<div className="col-sm-12">
					        			<label>Stretching:</label>
					        			<p>{item.selectedStretching.getIn(['title', 'rendered'])} ({Constants.Currency + item.stretchingTotal})</p>
					        		</div>
				        		</div>
			        		}

							{item.selectedWrapping.size > 0 &&
				        		<div className="popLine">
					        		<div className="col-sm-12">
					        			<label>Wrapping:</label>
					        			<p>{item.selectedWrapping.getIn(['title', 'rendered'])}</p>
					        		</div>
				        		</div>
			        		}

							{item.selectedHanging.size > 0 &&
				        		<div className="popLine">
					        		<div className="col-sm-12">
					        			<label>Hanging:</label>
					        			<p>{item.selectedHanging.getIn(['title', 'rendered'])}</p>
					        		</div>
				        		</div>
			        		}

							<div className="popLine">
				        		<div className="col-sm-12">
				        			<label>Quantity:</label>
				        			<p>{item.qty}</p>
				        		</div>
			        		</div>

			        		<div className="popLine">
				        		<div className="col-sm-12">
				        			<label>Total:</label>
				        			<p>{Constants.Currency + item.cart1ItemTotal}</p>
				        		</div>
			        		</div>

			        		<div className="clear"></div>

			        		<div className="row">
			        			<div className="col-sm-12 col-md-4">
			        				<a href="#!" className="btn btn-primary" onClick={this.props.editSaved.bind(this, viewArray)}>Edit</a>
			        			</div>
			        			<div className="col-sm-12 col-md-4">
			        				<a href="#!" className="btn btn-danger" onClick={this.props.deleteArray.bind(this, viewArray)}>Delete</a>
			        			</div>
			        			<div className="col-sm-12 col-md-4">
									<a href="#!" className="btn btn-primary default-btn single_add_to_cart_button" onClick={this.addToCart}>
										{this.state.cartLoading ?
											<div className="loading"></div> :
											<span>Add to cart</span>
										}
									</a>
			        			</div>
			        		</div>
			        	</div>
					)
				}
				{this.state.cartContent !== null &&
					<div className="clear">{Parser(this.state.cartContent)}</div>
				}
			</>
        );
    }
}